import './plan-subscription.style.sass';
import template from './plan-subscription.tpl.pug';

class PlanSubscriptionController {
    $onChanges(changeObject) {
        if (changeObject.frequency) {
            this.billing = this.frequency < 12 ? 'month' : 'year';
        }
    }

    get monthly() {
        if (this.frequency > 1) {
            let price = Number.prototype.toFixed.call(this.price / this.frequency, 2);
            return `${this.currency}${price} / month`;
        }

        return null;
    }

    select() {
        return this.onClick();
    }
}

export default {
    selector: 'dbPlanSubscription',
    template: template(),
    controller: PlanSubscriptionController,
    bindings: {
        currency: '<',
        price: '<',
        frequency: '<',
        free: '<',
        business: '<',
        upgrade: '<',
        onClick: '&'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/component/plan-subscription/plan-subscription.cmpt.js